// Angular
import { Component, Input } from '@angular/core';

// Afidium
import { ISummarySectorAir } from '../../shared/interfaces/ISummary';
import { faPlane, IconDefinition } from "@fortawesome/free-solid-svg-icons";

@Component({
    selector: 'sector-air-summary',
    template: `
        <div class="informations-container" [class.details-closed]="!detailsIsShown">

            <fa-icon *ngIf="showIcon" class="label-icon" [icon]="iconPlane"></fa-icon>

            <div class="informations">
                <travel-date [sector]="sector"></travel-date>
                <directions [class.no-host]="!showHost"
                            [from]="sector.from"
                            [to]="sector.to"
                            [begin]="sector.begin"
                            [end]="sector.end"
                            [detailsIsShown]="detailsIsShown"
                            [inline]="inlineDirections"></directions>
                <references *ngIf="showHost" [code]="sector.code" [host]="sector.host" [gdsStatus]="sector.seat?.status"></references>

                <div class="price"></div>
            </div>
        </div>
    `,
    styles: [`
        directions {
            display: block;
            margin-top: 10px;
            margin-bottom: 10px;
        }

        .informations-container {
            display: flex;
            align-items: baseline;
            text-align: left;
        }

        .label-icon {
            margin-right: 15px;
        }

        .travel-date {
            display: flex;
            flex-direction: column;
        }

        .duration {
            font-size: .95rem;
        }

        .informations > * {
            line-height: 20px;
        }

        .details-open {
            flex-direction: column;
        }

        .details-closed .informations {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
        }

        .no-host {
            margin-bottom: 0;
        }

        references ::ng-deep .references {
            display: flex;
            flex-direction: column;
        }

        references ::ng-deep .references btn.host .btn,
        references ::ng-deep .references .host {
            font-size: .85rem;
        }
    `]
})
export class SectorAirSummaryComponent {

    public iconPlane: IconDefinition = faPlane;

    @Input()
    public sector: ISummarySectorAir;

    @Input()
    public detailsIsShown: boolean = true;

    @Input()
    public showIcon: boolean = true;

    @Input()
    public showHost: boolean = true;

    @Input()
    public inlineDirections: boolean = false;
}
